import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';
import { store } from '../store';
import { hideLoading, showLoading } from '../actions';

function* getMyPageInfo(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(requestAPI, API.API_GET_MYPAGE_INFO, API.GET);

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_MY_PAGE_INFO_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({ type: types.GET_MY_PAGE_INFO_FAILED, error: response });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.GET_MY_PAGE_INFO_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* getBannerSlideData(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(requestAPI, API.API_GET_BANNER_SLIDE, API.GET);

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_BANNER_SLIDE_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({ type: types.GET_BANNER_SLIDE_FAILED, error: response });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.GET_BANNER_SLIDE_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchGetMyPageInfoSaga() {
  yield takeLatest(types.GET_MY_PAGE_INFO_REQUESTED, getMyPageInfo);
}

export function* watchGetBannerSlideData() {
  yield takeLatest(types.GET_BANNER_SLIDE_DATA, getBannerSlideData);
}
